import { Component, computed, input, linkedSignal, model, output } from '@angular/core';
import { AssetRecoveryReport } from '../../../../types';

@Component({
  selector: 'app-asset-recovery-invoice-modal',
  templateUrl: './asset-recovery-invoice-modal.component.html',
  standalone: false,
})
export class AssetRecoveryInvoiceModalComponent {
  public report = input.required<AssetRecoveryReport>();
  public readOnly = input<boolean>(false);
  public saving = input<boolean>(false);
  public isVisible = model<boolean>(false);
  public confirmed = output<number>();

  public addedFees = linkedSignal(() => this.report().added_fees);
  public totalAmount = computed(() => this.report().amount + this.addedFees());
  public qrCodeUrl = computed(
    () => `https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${encodeURIComponent(this.report().payment_url)}`,
  );

  public reset() {
    this.addedFees.set(this.report().added_fees);
  }

  public confirm() {
    this.confirmed.emit(this.addedFees() ?? 0);
  }
}
